import React from 'react';
import LeftChevron from '@repo/ui/src/components/Icons/LeftChevron';
import { classNames } from '@repo/ui/src/utils/classNames';

interface LeftArrowProps {
  className?: string;
  secondaryClass?: string;
  darkMode?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  onImage?: boolean;
  'aria-label'?: string | null;
  arrowSize?: string;
  hidden?: boolean;
  tabIndex?: number;
  role?: string;
  asSpan?: boolean;
}

const LeftArrow = ({
  className,
  secondaryClass,
  onClick,
  darkMode,
  onImage,
  tabIndex,
  arrowSize,
  'aria-label': label = 'previous',
  hidden,
  asSpan = false,
}: LeftArrowProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(event as unknown as React.MouseEvent<HTMLButtonElement | HTMLDivElement>);
    }
  };

  const commonProps = {
    tabIndex,
    className: classNames(
      className,
      secondaryClass,
      'before:tw-hidden tw-cursor-pointer focus-visible:tw-outline-2 focus-visible:tw-outline-action-300 tw-min-h-fit tw-min-w-fit tw-rounded-full focus-visible:tw-outline',
      !asSpan && 'tw-border-0 tw-bg-transparent',
      hidden && '!tw-hidden',
    ),
    onClick,
    onKeyDown: handleKeyDown,
    'aria-label': label ?? undefined,
  };

  if (asSpan) {
    return (
      <div {...commonProps}>
        <LeftChevron darkMode={darkMode} onImage={onImage} arrowSize={arrowSize} />
      </div>
    );
  }

  return (
    <button type="button" {...commonProps}>
      <LeftChevron darkMode={darkMode} onImage={onImage} arrowSize={arrowSize} />
    </button>
  );
};

export default LeftArrow;
